import { Box, Typography } from "@mui/material";
import React from "react";
import UploadButton from "./UploadButton";
import PreviewBox from "./PreviewBox";
import CustomButton from "../../../../../components/CustomButton";
import ArrowLeftCircle from "../../../../../../media/images/icons/arrow-left-circle";

export default function UploadDocuments() {
  const docs = [
    {
      title: "بارگذاری کارت ملی(صفحه رو)",
    },
    {
      title: "بارگذاری کارت ملی(صفحه پشت)",
    },
    {
      title: "بارگذاری کارت هوشمند راننده",
    },
    {
      title: "بارگذاری گواهینامه راننده",
    },
  ];

  return (
    <Box
      sx={{
        marginTop: "16px",
        width: "100%",
        backgroundColor: "background.default",
        padding: "16px",
        borderRadius: "16px",
      }}
    >
      <Typography
        sx={{
          textAlign: "center",
          fontWeight: "600",
          color: "secondary.dark",
          fontSize: "16px",
        }}
      >
        ثبت مشخصات ناوگان
      </Typography>
      <Box
        sx={{
          marginTop: "8px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        {docs.map((item) => (
          <UploadButton title={item.title} />
        ))}

        <PreviewBox />

        <CustomButton
          // loading={loading}
          // onClick={formik.handleSubmit}
          flexDirection="row"
          title="تکمیل مرحله و ادامه"
          justifyContent="center"
          bgColor="secondary.main"
          width="100%"
          fSize="16px"
          fontWeight={600}
          px="10px"
          py="10px"
          borderRadius="10px"
          icon2={<ArrowLeftCircle size={32} />}
          mt="16px"
        />
      </Box>
    </Box>
  );
}
